import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from "@angular/router";

import { RouteConfig } from "./router-config.model";

@Injectable({ providedIn: "root" })
export class ObgRouteReuseStrategy extends RouteReuseStrategy {
	shouldDetach(_route: ActivatedRouteSnapshot): boolean {
		return false;
	}

	store(_route: ActivatedRouteSnapshot, _detachedTree: DetachedRouteHandle) {
		// noop
	}

	shouldAttach(_route: ActivatedRouteSnapshot): boolean {
		return false;
	}

	retrieve(_route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
		return null;
	}

	shouldReuseRoute(newRoute: ActivatedRouteSnapshot, currentRoute: ActivatedRouteSnapshot): boolean {
		const currentConfig = currentRoute.routeConfig as RouteConfig;
		const newConfig = newRoute.routeConfig as RouteConfig;

		if (!newConfig && !currentConfig) {
			return true;
		}

		if (!newConfig || !currentConfig) {
			return false;
		}

		return newConfig.disableComponentSharing !== true && newConfig.component === currentConfig.component;
	}
}
